import connectedComponent from './ToolStylePopup';

export default connectedComponent;
